import { useSelector } from '~/_shared/utils/hooks/useSelector';
import type { AppState } from '~/store/app.store';

const mapInitializationFailedSelector = (state: AppState) => state.frontendState.mapInitializationFailed;
export const useMapInitializationFailedSelector = () => useSelector(mapInitializationFailedSelector);
